import React, { PureComponent } from 'react'
import { Button } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { getBackgroundTextColor } from '../../services/appServices'
import ColorModal from './ColorModal'

class ColorSelector extends PureComponent {
    state = {
        isOpenPalette: false
    }

    onOpenPalette() {
        this.setState({
            isOpenPalette: true
        })
    }

    onChangeColor(color) {
        if (color) {
            this.setState({ isOpenPalette: false })
            this.props.onChange(color)
        } else {
            this.setState({ isOpenPalette: false })
        }
    }

    render() {
        let { color, disableEditIcon, disableRemoveIcon, onRemove } = this.props
        return (
            <div>
                <Button.Group>
                    <Button
                        style={{
                            backgroundColor: color,
                            color: getBackgroundTextColor(color)
                        }}
                        onClick={() => this.onOpenPalette()}>
                        {color}
                    </Button>
                    {!disableEditIcon && (
                        <Button onClick={() => this.onOpenPalette()}>
                            <EditOutlined />
                        </Button>
                    )}
                    {!disableRemoveIcon && (
                        <Button onClick={() => onRemove()}>
                            <DeleteOutlined />
                        </Button>
                    )}
                </Button.Group>
                <ColorModal
                    color={color}
                    isOpen={this.state.isOpenPalette}
                    onOk={this.onChangeColor.bind(this)}
                />
            </div>
        )
    }
}

export default ColorSelector
